import React, { useCallback, useMemo } from 'react'

import { useLocation, navigate } from '@reach/router'

import { Button } from '@refera/ui-web'
import { useBudgetForm } from '_/views/budget-view-v2/hooks/use-budget-form'
import { useDialog } from '_/hooks/use-dialog'
import useRolePermission from '_/hooks/use-role-permission'

export default function CancelButton() {
  const { pathname } = useLocation()
  const { isEditing, setIsEditing, setResetForm, budget, setBudgetResolutionToEdit } =
    useBudgetForm()
  const isCreating = pathname.includes('/novo')
  const { closeDialog, showDialog } = useDialog()
  const { isTradesman } = useRolePermission()

  const showButton = useMemo(() => {
    if (isCreating || isEditing) {
      if (isTradesman && budget?.released) return false
      return true
    }
    return false
  }, [isCreating, isEditing, isTradesman, budget])

  const handleCancel = useCallback(() => {
    setResetForm(true)
    setBudgetResolutionToEdit(true)
    closeDialog()

    if (isCreating) return navigate(-1)
    setIsEditing(false)
    return null
  }, [isCreating])

  function handleClick() {
    showDialog({
      type: 'warning',
      subject: 'Cancelar',
      description: 'Você tem certeza que deseja executar esta ação?',
      onApprove: handleCancel,
      onCancel: closeDialog,
      labelApprove: 'Confirmar',
      labelCancel: 'Cancelar',
    })
  }

  if (!showButton) return null

  return (
    <Button onClick={handleClick} color="red" variant="secondary">
      Cancelar
    </Button>
  )
}
